import { render, staticRenderFns } from "./DialogReactivate.vue?vue&type=template&id=68bddf58"
import script from "./DialogReactivate.vue?vue&type=script&lang=js"
export * from "./DialogReactivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports